module.exports = __webpack_public_path__ + "static/r4-12e416bee09d7bdc3d844b5fc2143856.png";